import * as React from "react";
import SliderNavigation from "../Common/Slider/Navigation";
import Slider from "../Common/Slider";
import Section from "../Layout/Section";
import Link from "../UI/Link";
import Media from "../Common/Media";
import * as styles from "./cases.module.css";
import TemplateString from "../Common/TemplateString";

const Cases = ({items}) => {
    return (
        <Section>
            <Slider
                title="Кейсы внедрения ITSM 365"
                navigation={<SliderNavigation />}
                sliderClassName={styles.cases__slider}
                containerClassName={styles.cases__sliderContainer}
                titleClassName={styles.cases__sliderTitle}
            >
                {items.map(({id, url, value, valueDescription, description, logo}) => (
                    <div key={id}>
                        <div className={styles.cases__card}>
                            <div>
                                <div className={styles.cases__cardLogoWrapper}>
                                    <Media media={{content: logo}} />
                                </div>
                                <h3 className={styles.cases__cardValue}>
                                    <TemplateString template={value} />
                                </h3>
                                <p className={styles.cases__cardValueDesc}>
                                    <TemplateString template={valueDescription} />
                                </p>
                                <hr className={styles.cases__cardSeparator} />
                                <p className={styles.cases__cardDesc}>
                                    <TemplateString template={description} />
                                </p>
                            </div>
                            <Link to={url} withArrow>
                                Читать кейс
                            </Link>
                        </div>
                    </div>
                ))}
            </Slider>
            <div className={styles.cases__linkContainer}>
                <Link to="/blog?tags=clients-experience " withArrow>
                    Все кейсы
                </Link>
            </div>
        </Section>
    );
};

export default Cases;
